import { DROFUS_INTERFACE_OCCURRENCE_FIELD_META } from "@multiconsult-group/multiplacer-core";

type ChangeReasonInput = {
  changeType: "added" | "removed" | "updated";
  changeKey: string;
  normalizedPath?: string;
  fieldId?: string;
  displayName?: string;
  affectedDisciplines: readonly string[];
};

export function getDrofusChangeReason(row: ChangeReasonInput) {
  const path = row.normalizedPath ?? row.fieldId ?? row.changeKey.replace(/^normalized:/, "");
  // Use the same primary field metadata as the snapshot comparison.
  const field = DROFUS_INTERFACE_OCCURRENCE_FIELD_META.find((item) => item.normalizedPath === path);
  const fieldName = row.displayName ?? field?.displayName ?? path;
  const entityChange = row.changeType !== "updated";
  const title = entityChange
    ? row.changeType === "added"
      ? "Ny forekomst"
      : "Fjernet forekomst"
    : `${fieldName} endret`;
  const explanation = entityChange
    ? "Forekomsten er lagt til eller fjernet mellom to innlesninger. Ingen enkeltfelt utløste endringen."
    : field
      ? field.affectedDiscipline
        ? "Feltets verdi er endret. Dette behovsfeltet er knyttet direkte til faget."
        : "Felles felt er endret. Berørte fag følger forekomstens behov før eller etter endringen; fagets eget behovsfelt trenger ikke å være endret."
      : "Feltets verdi er endret. Berørte fag er hentet fra den registrerte endringen; koblingen til feltet er ikke kjent.";

  return {
    title,
    explanation,
    disciplines: row.affectedDisciplines.map((discipline) => ({
      discipline,
      reason: entityChange
        ? "Forekomsten berører faget"
        : field?.affectedDiscipline === discipline
          ? "Fagets behovsfelt endret"
          : field && !field.affectedDiscipline
            ? "Felles felt · fag tilknyttet forekomsten"
            : "Registrert som berørt fag",
    })),
  };
}

export function formatDrofusChangeReason(row: ChangeReasonInput): string {
  const reason = getDrofusChangeReason(row);
  return [
    reason.title,
    ...reason.disciplines.map((item) => `${item.discipline}: ${item.reason}`),
    reason.explanation,
  ].join("\n");
}
